import { render } from "./reset_password.vue?vue&type=template&id=c75bc70e"
import script from "./reset_password.vue?vue&type=script&lang=js"
export * from "./reset_password.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__